import { useQuery } from '@tanstack/react-query';

import { IDeclaracaoHastaPublica } from '../../../../interfaces/IDeclaracoes';
import CustomTab from '../../../../components/customTab/customTab';
import { useBackEndRequests } from '../../lib/backEndRequests';
import ErrorMessage from '../../../../components/errorMessage/errorMessage';
import { useNavigate } from 'react-router-dom';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';

function HastaPublicaTab({ year }: { year: string }) {
  const cnpj = sessionStorage.getItem('userCpfCnpj');

  const { getDeclaracoes } = useBackEndRequests();

  const {
    data: declaracoesData,
    isLoading: isDeclaracoesLoading,
    isError: isDeclaracoesError,
    error: DeclaracoesError,
  } = useQuery<IDeclaracaoHastaPublica[], IErrorWithSentryId>({
    queryKey: ['declaracaoHastaPublicaQuery', [year, cnpj]],
    queryFn: () => getDeclaracoes(cnpj || '', year, 1),
    refetchOnWindowFocus: false,
    retryDelay: 100,
  });

  const navigate = useNavigate();

  return (
    <>
      {isDeclaracoesError ? (
        <ErrorMessage
          errorMessage={DeclaracoesError?.message}
          error={DeclaracoesError}
          onClickFunction={() => navigate(0)}
        />
      ) : (
        <CustomTab
          declaracoesData={declaracoesData || []}
          isDeclaracoesLoading={isDeclaracoesLoading}
          declaracaoType='hasta-publica'
          ano={year}
        />
      )}
    </>
  );
}

export default HastaPublicaTab;
